import React from 'react'
import { Link } from 'react-router-dom'

import styles from './Chrome.module.css'

export default ({ children }) => (
  <header className={styles.chrome}>
    <Link to="/">Data Looks Dope</Link>
  </header>
)
